import { CmpEventFieldsFragment, CmpEventStatusEnum } from "../../../../graphql/types";
import { EventFormState } from "../eventMockData";

type DuplicateSourceRecord = Pick<CmpEventFieldsFragment, "title" | "status" | "duplicatedFromEventId">;

/**
 * EV-N2 "not yet changed" rule for a Duplicate Event copy.
 *
 * The backend sets duplicatedFromEventId on the copy and clears it on the
 * copy's first successful updateCmpEvent, Save Draft included (Save Draft
 * saves the event itself since Monday 13290832990). An older side draft
 * (CMP_EVENT_DRAFT) of the copy does not clear it.
 * While the flag is set and the saved record is still a Draft, the wizard
 * treats the copy as needing its own title (design dupEdit):
 * - It clears Event Title and Event Code only while the loaded title still
 *   equals the saved record's generated "<name> (Copy)" title. A working
 *   draft with a new title keeps that title.
 * - It shows the duplicate notice while the title is empty. Event Code is
 *   optional, so a blank code does not keep the notice open.
 */
export const applyDuplicateEventSetup = ({
  event,
  record,
}: {
  event: EventFormState;
  record?: DuplicateSourceRecord | null;
}): { event: EventFormState; duplicated: boolean } => {
  if (!record?.duplicatedFromEventId || record.status !== CmpEventStatusEnum.Draft) {
    return { event, duplicated: false };
  }
  const titleUnchanged = event.title.trim() === record.title.trim();
  return {
    duplicated: true,
    event: titleUnchanged ? { ...event, title: "", eventCode: "" } : event,
  };
};
